export default {
    Metadata: {
        Name: "IsNumeric",
        Description: "Returns true if the value is a number, otherwise false.",
        Syntax: "IsNumeric(value)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(value) {
        if (value == null) {
            return false;
        }
        return Number.isNumeric(value);
    },
};

